import { httpClient2 } from 'src/infrastructure/admi-client/http-client';
import {
    OnsiteVisitsResponseDto,
    OnsiteVisitSearchDto,
    OnsiteVisitTemplateDto,
    AttachmentDto,
    FormResponseDto,
    FormSubmitPayloadDto,
} from './onsite-visit.dto';

export const admiOnsiteVisitService = {
    getOnsiteVisits: async (search: OnsiteVisitSearchDto, signal?: AbortSignal): Promise<OnsiteVisitsResponseDto> => {
        const params: Record<string, string | number> = {
            page: search.page,
            size: search.size,
            sort: search.sort,
        };

        if (search.status) params.status = search.status;
        if (search.templateId) params.templateId = search.templateId;
        if (search.visitDateFrom) params.from = new Date(search.visitDateFrom).toISOString();
        if (search.visitDateTo) params.to = new Date(search.visitDateTo).toISOString();

        const response = await httpClient2.get<OnsiteVisitsResponseDto>('/v1/onsite-visits', { params, signal });

        return response.data;
    },

    getOnsiteTemplates: async (): Promise<OnsiteVisitTemplateDto[]> => {
        const response = await httpClient2.get<OnsiteVisitTemplateDto[]>('/v1/onsite-templates');
        return response.data;
    },

    uploadAttachment: async (file: File, questionId: string): Promise<AttachmentDto> => {
        const formData = new FormData();
        formData.append('file', file);

        const response = await httpClient2.post<AttachmentDto>('/v1/onsite-visits/attachments/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            params: {
                questionId,
            },
        });

        return response.data;
    },

    // Polymorphic form API methods
    getPolymorphicFormQuestions: async (externalId: string): Promise<FormResponseDto> => {
        const response = await httpClient2.get<FormResponseDto>(`/v1/onsite-visits/${externalId}/questions`);
        return response.data;
    },

    submitPolymorphicForm: async (visitId: string, payload: FormSubmitPayloadDto): Promise<void> => {
        await httpClient2.post(`/v1/onsite-visits/${visitId}/submit`, payload);
    },
};
